import { z } from 'zod';

export const ExternalSearchReachOutModalSchema = z.object({
  firstName: z.string(),
  lastName: z.string(),
  email: z.string(),
  phoneNumber: z.string().nullable(),
  agreeToTermsOfService: z.boolean(),
  createAccount: z.boolean().default(false),
  activeFilters: z
    .object({
      barredLocations: z.array(z.string().nullish()).nullish(),
      businessTitles: z.array(z.string().nullish()).nullish(),
      practiceAreas: z.array(z.string().nullish()).nullish(),
      availabilityStatuses: z.array(z.string().nullish()).nullish(),
      industries: z.array(z.string().nullish()).nullish(),
      state: z.array(z.string().nullish()).nullish(),
      yearsOfExperience: z.array(z.string().nullish()).nullish(),
      countries: z.array(z.string().nullish()).nullish(),
    })
    .nullable(),
});

export type ExternalSearchReachOutModal = z.infer<
  typeof ExternalSearchReachOutModalSchema
>;
